<template>
  <div>
    <div id="map"></div>
    <v-btn
      @click="zoomToFit"
      small
      tile
      color="white text-capitalize font-weight-bold"
      >zoom to fit</v-btn
    >
  </div>
</template>

<script>
/* eslint-disable */
import gmapsInit from "@/externals/utils/Gmaps";
let geocoder = null;
let map = null;
let directionsDisplay = null;
let directionsService = null;

let b1 = null;
let b2 = null;

const getGeocode = (address) => {
  return new Promise((resolve, reject) => {
    geocoder.geocode({ address: address }, (results, status) => {
      if (status === "OK") {
        resolve(results[0].geometry.location);
      } else {
        reject(status);
      }
    });
  });
};

export default {
  name: "Map",

  props: {
    places: {
      type: Array,
      required: true,
    },
  },

  methods: {
    async initialize() {
      try {
        geocoder = new google.maps.Geocoder();
        directionsDisplay = new google.maps.DirectionsRenderer({
          polylineOptions: {
            strokeColor: "#EA4335",
          },
          // suppressMarkers: true,
        });
        directionsService = new google.maps.DirectionsService();

        const origin = await getGeocode(this.places[0]);
        var mapOptions = {
          zoom: 7,
          center: origin,
        };

        map = new google.maps.Map(document.getElementById("map"), mapOptions);
        directionsDisplay.setMap(map);
      } catch (error) {
        console.log(error);
      }
    },

    zoomToFit() {
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(b1);
      bounds.extend(b2);
      map.fitBounds(bounds);
    },

    async calcRoute() {
      const start = await getGeocode(this.places[0]);
      const end = await getGeocode(this.places[1]);

      b1 = start;
      b2 = end;

      this.zoomToFit();

      var request = {
        origin: start,
        destination: end,
        travelMode: google.maps.TravelMode.DRIVING,
      };

      directionsService.route(request, function(response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response);
          directionsDisplay.setMap(map);
        } else {
          console.log(
            "Directions Request from " +
              start.toUrlValue(6) +
              " to " +
              end.toUrlValue(6) +
              " failed: " +
              status
          );
        }
      });
    },
  },

  async mounted() {
    const google = await gmapsInit();
    this.initialize();
  },

  watch: {
    places() {
      this.calcRoute();
    },
  },
};
</script>

<style scoped>
#map {
  height: 400px;
  width: 100%;
}
</style>
